document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("wishlist-btn");
  const storageKey = "wishlist";

  if (!btn) return;

  const handle = window.location.pathname.split("/products/")[1];

  let items = JSON.parse(localStorage.getItem(storageKey)) || [];

  // 初期状態の表示
  if (items.includes(handle)) {
    btn.innerText = "♥ お気に入り済み";
  }

  btn.addEventListener("click", function () {

    let items = JSON.parse(localStorage.getItem(storageKey)) || [];

    if (items.includes(handle)) {
      items = items.filter(item => item !== handle);
      btn.innerText = "♡ お気に入り";
    } else {
      items.push(handle);
      btn.innerText = "♥ お気に入り済み";
    }

    localStorage.setItem(storageKey, JSON.stringify(items));
  });

});